import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppShell } from "./components/AppShell";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { PrivacyPolicy, TermsConditions, CookiesPolicy } from "./pages/Legal";
import { CookieConsent } from "./components/CookieConsent";
import ClientDashboard from "./pages/client/ClientDashboard";
import PublishWizard from "./pages/client/PublishWizard";
import FreightDetail from "./pages/FreightDetail";
import CarrierDashboard from "./pages/carrier/CarrierDashboard";
import CarrierOnboarding from "./pages/carrier/CarrierOnboarding";
import CarrierEarnings from "./pages/carrier/CarrierEarnings";
import CarrierCompany from "./pages/carrier/CarrierCompany";
import CarrierDrivers from "./pages/carrier/CarrierDrivers";
import CarrierVehicles from "./pages/carrier/CarrierVehicles";
import CarrierServices from "./pages/carrier/CarrierServices";
import CarrierAgenda from "./pages/carrier/CarrierAgenda";
import ClientCompany from "./pages/client/ClientCompany";
import ReturnTrips from "./pages/ReturnTrips";
import AdminAgenda from "./pages/admin/AdminAgenda";
import ServiceDetail from "./pages/ServiceDetail";
import AdminDashboard from "./pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <CookieConsent />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/legal/privacidad" element={<PrivacyPolicy />} />
            <Route path="/legal/terminos" element={<TermsConditions />} />
            <Route path="/legal/cookies" element={<CookiesPolicy />} />

            <Route element={<AppShell />}>
              <Route path="/app/client" element={<ProtectedRoute roles={["CLIENT"]}><ClientDashboard /></ProtectedRoute>} />
              <Route path="/app/client/publish" element={<ProtectedRoute roles={["CLIENT"]}><PublishWizard /></ProtectedRoute>} />
              <Route path="/app/client/company" element={<ProtectedRoute roles={["CLIENT"]}><ClientCompany /></ProtectedRoute>} />
              <Route path="/app/client/agenda" element={<ProtectedRoute roles={["CLIENT"]}><CarrierAgenda /></ProtectedRoute>} />
              <Route path="/app/freight/:id" element={<ProtectedRoute roles={["CLIENT"]}><FreightDetail /></ProtectedRoute>} />
              <Route path="/app/carrier" element={<ProtectedRoute roles={["CARRIER"]}><CarrierDashboard /></ProtectedRoute>} />
              <Route path="/app/carrier/onboarding" element={<ProtectedRoute roles={["CARRIER"]}><CarrierOnboarding /></ProtectedRoute>} />
              <Route path="/app/carrier/company" element={<ProtectedRoute roles={["CARRIER"]}><CarrierCompany /></ProtectedRoute>} />
              <Route path="/app/carrier/drivers" element={<ProtectedRoute roles={["CARRIER"]}><CarrierDrivers /></ProtectedRoute>} />
              <Route path="/app/carrier/vehicles" element={<ProtectedRoute roles={["CARRIER"]}><CarrierVehicles /></ProtectedRoute>} />
              <Route path="/app/carrier/earnings" element={<ProtectedRoute roles={["CARRIER"]}><CarrierEarnings /></ProtectedRoute>} />
              <Route path="/app/carrier/services" element={<ProtectedRoute roles={["CARRIER"]}><CarrierServices /></ProtectedRoute>} />
              <Route path="/app/carrier/agenda" element={<ProtectedRoute roles={["CARRIER"]}><CarrierAgenda /></ProtectedRoute>} />
              <Route path="/app/service/:id" element={<ProtectedRoute roles={["CLIENT", "CARRIER"]}><ServiceDetail /></ProtectedRoute>} />
              <Route path="/app/returns" element={<ProtectedRoute roles={["CLIENT", "CARRIER", "ADMIN"]}><ReturnTrips /></ProtectedRoute>} />
              <Route path="/app/admin" element={<ProtectedRoute roles={["ADMIN"]}><AdminDashboard /></ProtectedRoute>} />
              <Route path="/app/admin/agenda" element={<ProtectedRoute roles={["ADMIN"]}><AdminAgenda /></ProtectedRoute>} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
